module.exports = __webpack_public_path__ + "static/img/BrechtGeorge_MallardMilk_fromTudorfiles.24bc3dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/BrechtGeorge_MallardMilk_fromTudorfiles.jpg
// module id = ES94
// module chunks = 0